/**
 * Updates the recently viewed products in localStorage.
 *
 * Stores product *handles* (not ids). The search dropdown resolves them via Liquid's
 * `all_products[handle]`, which returns any published product regardless of stock or
 * search-index status. Looking them up via storefront search instead silently dropped
 * sold-out and search-excluded products, so the list rendered short (e.g. 18/20).
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed product handles in local storage.
   * Distinct from the legacy 'viewedProducts' (which held ids) so old id data is ignored, not mixed in. */
  static #STORAGE_KEY = 'viewedProductHandles';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 20;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productHandle - The handle of the product to add.
   */
  static addProduct(productHandle) {
    if (!productHandle) return;

    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ handle) => handle !== productHandle);
    viewedProducts.unshift(productHandle);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed product handles from local storage.
   * @returns {string[]} The list of viewed product handles.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }
}
